module.exports = __webpack_public_path__ + "static/media/bank.64ee76d0.svg";